<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto flex max-w-screen-xl flex-col">
      <div v-if="title" class="mb-4 text-center text-2xl font-bold lg:text-4xl">
        {{ title }}
      </div>
      <div v-if="subtitle" class="mb-8 text-center text-lg font-bold">{{ subtitle }}</div>
      <VcInput class="mx-auto max-w-lg" :placeholder="placeholder" />
      <div class="text-center">
        <div class="mt-4">
          <VcCheckbox class="inline-flex">
            <span v-html-safe="checkboxText" class="checkbox-label"></span>
          </VcCheckbox>
        </div>

        <VcButton class="mt-10 px-12">
          {{ buttonText }}
        </VcButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  title?: string;
  subtitle?: string;
  placeholder?: string;
  checkboxText?: string;
  buttonText?: string;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)]",
    props.bottomMargin ? props.bottomMargin : "my-0",
    props.verticalPadding ? props.verticalPadding : "py-10 lg:py-20",
    "block-subscribe-form",
  ];
});
</script>

<style lang="scss">
.block-subscribe-form .checkbox-label a {
  @apply text-[--link-color] hover:text-[--link-hover-color];
}
</style>
